/**
 * 実績チェッカー
 *
 * ゲーム終了時に実績条件を判定し、localStorage に保存する。
 */
import { ACHIEVEMENTS, type Achievement, type ScoreMetadata } from '../config/achievements';
import { loadAchievements, saveAchievements, type AchievementData } from './storage';

// 型の再エクスポート（既存の import を壊さないため）
export type { AchievementData as AchievementCookie };
export { loadAchievements } from './storage';
export type { AchievementStatus } from './storage';

/**
 * 実績判定 + localStorage 保存
 * @returns 今回新たに達成した実績リスト
 */
export function checkAndUnlockAchievements(
  mapType: string,
  metadata: ScoreMetadata,
): Achievement[] {
  const unlocked: Achievement[] = [];
  const data = loadAchievements();
  const mapAchievements = ACHIEVEMENTS.filter(a => a.mapType === mapType);

  for (const achievement of mapAchievements) {
    // 既にアンロック済みならスキップ
    if (data[mapType]?.[achievement.id]?.unlocked) continue;

    if (achievement.checkCondition(metadata)) {
      unlockAchievement(achievement);
      unlocked.push(achievement);
    }
  }

  return unlocked;
}

function unlockAchievement(achievement: Achievement): void {
  const data = loadAchievements();

  if (!data[achievement.mapType]) {
    data[achievement.mapType] = {};
  }

  data[achievement.mapType][achievement.id] = {
    unlocked: true,
    unlockedAt: new Date().toISOString(),
  };

  saveAchievements(data);
}
